// extracted by mini-css-extract-plugin
export default {"action":"skills_action__WqmCq","skillsList":"skills_skillsList__3ajhJ","chip":"skills_chip__caMIJ"};